import { getAuth } from "../common/Helpers";

const authHeaderJson = () => {
  return { 
    'Content-Type': 'application/json', 'handlerichtextsg3': 'handlerichtextsg3'
  };
}

const authHeaderJsonAuth = (cookie) => {
  return { 
    'Content-Type': 'application/json', 'handlerichtextsg3': 'handlerichtextsg3',
    'AuthTk': cookie.tk,
    'AuthTkr': cookie.rtk
  };
}

const authHeaderFile = () => {
  var user = null;
  return {
    'Content-Type': 'multipart/form-data'
  };
}

const authHeaderRecaptcha = () => {
  return { 'Content-Type': 'application/json', 'handletokensg3': 'handletokensg3' };
}


export {authHeaderFile,authHeaderJson,authHeaderJsonAuth, authHeaderRecaptcha}